import { render, staticRenderFns } from "./RulesEditor.vue?vue&type=template&id=235f865c"
import script from "./RulesEditor.vue?vue&type=script&lang=js"
export * from "./RulesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports